'use client';

import { DotLottieReact } from '@lottiefiles/dotlottie-react';

export default function LoaderClient() {
    return (
        <DotLottieReact
            src="/fc-loader.json"
            autoplay
            loop
            style={{ width: 120, height: 120 }}
        />
    );
}
